// Raw platform strings can vary in casing between records for the same
// real platform (e.g. "ANODU" from an automated integration vs "Anodu" from
// exaport's own upload form/config) - normalize_platform_name resolves a
// raw value to its canonical display name from the config collection
// (case-insensitive match), which is the actual source of truth for how a
// platform's name should be spelled/cased. Falls back to simple Title Case
// for anything with no config match, rather than leaving inconsistent raw
// casing on screen - deliberately not a blanket Title Case of everything,
// since that would mangle intentionally-styled names like "FinBee" into
// "Finbee".

const title_case = (str) => {
  return str
    .split(' ')
    .map(word => (word.length > 0 ? word[0].toUpperCase() + word.slice(1).toLowerCase() : word))
    .join(' ');
};

const normalize_platform_name = (raw_name, canonical_platforms_list) => {
  if (!raw_name) {
    return raw_name;
  }
  let match = (canonical_platforms_list || []).find(
    p => p.platform?.toLowerCase() === raw_name.toLowerCase()
  );
  return match ? match.platform : title_case(raw_name);
};

export { normalize_platform_name };
